$(document).ready(function () {
    $('.dif-slider').slick({
        autoplay: true,
        autoplaySpeed: 1500,
        dots: false,
        arrows: false,
        infinite: true,
        cssEase: 'linear',
        pauseOnHover: false,
        fade: true,
    });

    $('.dif-gallery-slider').slick({
        autoplay: true,
        autoplaySpeed: 6000,
        dots: true,
        arrows: false,
        infinite: true,
        cssEase: 'linear',
        fade: true,
    });

    $('.nd-review-slider').slick({
        autoplay: true,
        autoplaySpeed: 6000,
        dots: true,
        arrows: false,
        infinite: true,
        cssEase: 'linear',
        fade: true,
    });

    $('.js-other-products').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: true,
        infinite: true,
        dots: false,
        arrows: false,
        centerMode: true,
        centerPadding: '0',
        initialSlide: 0,

        responsive: [
            {
              breakpoint: 800,
              settings: {
                dots: true,
                variableWidth: true,
              }
            },
          ]
    });

    $('.js-team-slider').slick({
        variableWidth: true,
        dots: true,
        arrows: false,
        infinite: true,
        cssEase: 'linear',
    });

    $('.js-thimbnails-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 2,
    });

    $('.drop-in-filters-selection .filter-nav').click(function () {
        $('.filter-nav').removeClass('active');
        $(this).addClass('active');
    });

    $('#circular-polarizer').click(function () {
        $('.filter-details').removeClass('show');
        $('#circular-polarizer-det').addClass('show');
    });

    $('#dark-cpl').click(function () {
        $('.filter-details').removeClass('show');
        $('#dark-cpl-det').addClass('show');
    });

    $('#neutral-density').click(function () {
        $('.filter-details').removeClass('show');
        $('#neutral-density-det').addClass('show');
    });

    $('#vnd-r').click(function () {
        $('.filter-details').removeClass('show');
        $('#vnd-r-det').addClass('show');
    });

    $('#autumn-night-sky').click(function () {
        $('.filter-details').removeClass('show');
        $('#autumn-night-sky-det').addClass('show');
    });

    $('#infrared').click(function () {
        $('.filter-details').removeClass('show');
        $('#infrared-det').addClass('show');
    });

    $('#clear').click(function () {
        $('.filter-details').removeClass('show');
        $('#clear-det').addClass('show');
    });

    $('#black-white').click(function () {
        $('.filter-details').removeClass('show');
        $('#bw-cpl-det').addClass('show');
    });
});
